export const APPROVED_STRIPE_CONNECT_COUNTRIES = [
  // North America
  "CA", // Canada
  "MX", // Mexico
  "US", // United States

  // Europe
  "AT", // Austria
  "BE", // Belgium
  "BG", // Bulgaria
  "HR", // Croatia
  "DK", // Denmark
  "EE", // Estonia
  "FI", // Finland
  "FR", // France
  "DE", // Germany
  "GR", // Greece
  "HU", // Hungary
  // "IS", // Iceland -> not supported by Stripe
  "IE", // Ireland
  "IT", // Italy
  "LU", // Luxembourg
  "NL", // Netherlands
  "NO", // Norway
  "PL", // Poland
  "PT", // Portugal
  "RO", // Romania
  "SK", // Slovakia
  "SI", // Slovenia
  "ES", // Spain
  "SE", // Sweden
  "CH", // Switzerland
  "GB", // United Kingdom

  // Asia
  "JP", // Japan
  // "KR", // South Korea -> not supported by Stripe
  "SG", // Singapore
  "AE", // United Arab Emirates
  "HK", // Hong Kong

  // Oceania
  "AU", // Australia
  "NZ", // New Zealand
];
